export default {"src":"/_next/static/media/Afterpay-Badge-BlackonMint.cd3a513d.svg","height":550,"width":1582,"blurWidth":0,"blurHeight":0};